import { render, staticRenderFns } from "./DatasetTableEditor.vue?vue&type=template&id=5bc4f1de&scoped=true"
import script from "./DatasetTableEditor.vue?vue&type=script&lang=js"
export * from "./DatasetTableEditor.vue?vue&type=script&lang=js"
import style0 from "./DatasetTableEditor.vue?vue&type=style&index=0&id=5bc4f1de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc4f1de",
  null
  
)

export default component.exports